import { render, staticRenderFns } from "./freightreceipt.vue?vue&type=template&id=1c41fe52&"
import script from "./freightreceipt.vue?vue&type=script&lang=js&"
export * from "./freightreceipt.vue?vue&type=script&lang=js&"
import style0 from "./freightreceipt.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports